import {
  CreatePushParams,
  PushRepository,
  UpdatePushParams
} from "@/features/push/domain/repositories/push";
import { captureError } from "@/shared/services/sentry";

export const pushUseCases = (repository: PushRepository) => ({
  createPush: async <T>(params: CreatePushParams): Promise<T> => {
    try {
      return await repository.createPush(params);
    } catch (e: any) {
      throw Error(e, {
        cause: e.cause
      });
    }
  },
  getPushList: async <T>(): Promise<T> => {
    try {
      return await repository.getPushList();
    } catch (e: any) {
      throw Error(e, {
        cause: e.cause
      });
    }
  },
  getPushById: async <T>(id?: string): Promise<T> => {
    try {
      if (!id) {
        throw Error("id is required");
      }
      return await repository.getPushById(id);
    } catch (e: any) {
      throw Error(e, {
        cause: e.cause
      });
    }
  },
  deletePush: async <T>(id: string): Promise<T> => {
    try {
      if (!id) {
        throw Error("id is required");
      }
      return await repository.deletePush(id);
    } catch (e: any) {
      throw Error(e, {
        cause: e.cause
      });
    }
  },
  updatePush: async <T>({
    id,
    params
  }: {
    id: string;
    params: Partial<UpdatePushParams>;
  }): Promise<T> => {
    try {
      if (!id || id === "") {
        throw Error("id is required");
      }
      return await repository.updatePush({ id, params });
    } catch (e: any) {
      throw Error(e, {
        cause: e.cause
      });
    }
  },
  getPushCalendarRestrictions: async <T>(): Promise<T> => {
    try {
      return await repository.getPushCalendarRestrictions();
    } catch (e: any) {
      throw Error(e, {
        cause: e
      });
    }
  },
  getCalendarRestrictionsByPushId: async <T>(id: string): Promise<T> => {
    try {
      if (!id || id === "") {
        throw Error("Push id is required");
      }

      return await repository.getCalendarRestrictionsByPushId(id);
    } catch (e: any) {
      throw Error(e, {
        cause: e
      });
    }
  },
  getPushCalendarDates: async <T>(): Promise<T> => {
    try {
      return await repository.getPushCalendarDates();
    } catch (e: any) {
      throw Error(e, {
        cause: e
      });
    }
  },
  getPushPrices: async <T>(): Promise<T> => {
    try {
      return await repository.getPushPrices();
    } catch (e: any) {
      throw Error(e, {
        cause: e
      });
    }
  },
  getPushDiscountDurations: async <T>(): Promise<T> => {
    try {
      return await repository.getPushDiscountDurations();
    } catch (e: any) {
      throw Error(e, {
        cause: e
      });
    }
  }
});

export default pushUseCases;
